<script lang="ts" setup>
import Modal from "~/components/ui/modals/Modal.vue";
import useSearchStore from "~/shared/store/modules/search";
import AppButton from "~/components/ui/buttons/AppButton.vue";

defineProps<{
  modalTitle: string
  modalText: string
}>()

const searchStore = useSearchStore()
</script>

<template>
  <Modal
    :modal-is-open="searchStore.isSuccessModal"
    :modal-title="modalTitle"
    @close-modal="searchStore.setSuccessModalState(false)"
  >
    <p
      class="modal__text"
      v-html="modalText"
    ></p>
    <AppButton
      class="modal__button"
      text="Понятно"
      @click="searchStore.setSuccessModalState(false)"
    />
  </Modal>
</template>

<style lang="scss" scoped>
.modal {
  :deep(.modal-content) {
    max-width: 416px;
    width: 100%;

    @include xs-breakpoint {
      max-width: none;
    }
  }

  &__text {
    margin-top: 12px;
    @include xs-breakpoint {
      margin-top: 16px;
    }
  }

  &__button {
    width: 50%;
    margin-top: 28px;
    @include xs-breakpoint {
      margin-top: 16px;
    }
  }
}
</style>
